import axios, { AxiosInstance } from 'axios'
import { appPreferences } from 'src/boot/preferences'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $axios: AxiosInstance
  }
}

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const Boot = async ({ app }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  axios.defaults.baseURL = await appPreferences.getApiUrl()

  const token = await appPreferences.getAuthToken()
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

  app.config.globalProperties.$axios = axios

  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.provide('axios', axios)
}

export default Boot

export { axios }
